import { imageFilesTypes } from 'modules';

export const isAcceptableImgType = (imageObject) => imageFilesTypes.some(({ type }) => type === imageObject.type);
